module.exports = __webpack_public_path__ + "static/media/sticker-bc1021-view.13525fb8.jpg";